// extracted by mini-css-extract-plugin
export default {"titleWrap":"MypageContentHeader_titleWrap__D9Ug-"};